var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_369_3961)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 68,
    height: 68,
    rx: 34,
    fill: "#85CDFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5455,
    y: 11.5455,
    width: 64.9091,
    height: 64.9091,
    rx: 32.4545,
    stroke: "white",
    strokeWidth: 3.09091
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4541 33.4197C25.5072 33.2255 25.5565 33.0294 25.6125 32.8363C26.0646 31.286 27.5269 30.1472 29.1439 30.1008C29.7456 30.0834 30.3493 30.094 30.9511 30.094C40.134 30.094 49.3169 30.0931 58.5007 30.094C60.4123 30.094 61.9065 31.229 62.3605 33.012C62.9536 35.3409 61.2014 37.6841 58.7973 37.7498C57.7502 37.7788 56.7022 37.7547 55.605 37.7547C55.5113 38.3931 55.4156 39.0171 55.3268 39.643C54.9839 42.0626 54.6497 44.4832 54.299 46.9009C54.1155 48.1614 53.1168 49.0104 51.8495 49.0201C50.5832 49.0297 49.5825 48.1874 49.3855 46.926C49.2309 45.9388 49.0996 44.9487 48.9556 43.9597C48.9392 43.8466 48.9122 43.7356 48.831 43.6322C48.5838 45.3689 48.3375 47.1056 48.0902 48.8423C47.6661 51.8337 47.2421 54.8252 46.8181 57.8166C46.6896 58.7226 46.564 59.6286 46.4298 60.5337C46.2385 61.8251 45.263 62.6761 43.9744 62.6838C42.6792 62.6915 41.6872 61.8299 41.5007 60.5153C40.8459 55.9157 40.1958 51.3151 39.5438 46.7144C39.3989 45.6896 39.2482 44.6657 39.0329 43.6312C38.9691 44.0427 38.9015 44.4542 38.8426 44.8657C38.4021 47.9769 37.9665 51.0881 37.5241 54.1983C37.3396 55.4965 36.3747 56.3445 35.0813 56.3581C33.7764 56.3706 32.7989 55.5699 32.6009 54.2563C32.2261 51.769 31.8822 49.276 31.5287 46.7859C31.1114 43.8418 30.6971 40.8977 30.2807 37.9536C30.273 37.8957 30.2469 37.8406 30.2305 37.7885C29.7041 37.7595 29.1825 37.772 28.6754 37.6948C27.0672 37.4475 25.8269 36.2237 25.5227 34.6299C25.5101 34.5614 25.4773 34.4976 25.4541 34.4319C25.4541 34.0948 25.4541 33.7568 25.4541 33.4197ZM43.9696 32.2625C42.7284 32.2625 41.4872 32.2625 40.2451 32.2625C36.6055 32.2625 32.965 32.2596 29.3255 32.2644C28.3644 32.2654 27.6303 32.9908 27.6255 33.9152C27.6197 34.8415 28.346 35.5678 29.3032 35.5891C29.6046 35.5959 29.906 35.5891 30.2073 35.592C31.3519 35.6007 32.2386 36.3657 32.4009 37.4919C32.626 39.0528 32.8423 40.6147 33.0645 42.1766C33.6102 46.0141 34.1579 49.8517 34.7046 53.6893C34.7365 53.9124 34.7133 54.1761 35.0456 54.1867C35.3875 54.1973 35.3576 53.9182 35.4049 53.7047C35.4204 53.6342 35.4232 53.5618 35.4339 53.4903C35.5884 52.394 35.743 51.2967 35.8985 50.2004C36.3225 47.209 36.7465 44.2166 37.1715 41.2252C37.3869 39.7116 37.5946 38.197 37.8226 36.6854C37.9501 35.8393 38.7972 35.3669 39.5564 35.6992C40.0944 35.9349 40.276 36.3937 40.3513 36.9394C40.7628 39.9086 41.1839 42.8769 41.6041 45.8441C42.0262 48.824 42.4541 51.8028 42.8772 54.7827C43.1273 56.5464 43.3717 58.3111 43.6209 60.0759C43.6499 60.2816 43.6789 60.5037 43.9571 60.5105C44.2343 60.5182 44.2806 60.3067 44.3106 60.0952C44.3676 59.702 44.4188 59.308 44.4738 58.9148C44.894 55.9466 45.3132 52.9784 45.7343 50.0111C46.1584 47.0197 46.5814 44.0273 47.0074 41.0359C47.216 39.5696 47.416 38.1024 47.6459 36.64C47.7463 35.9996 48.2737 35.5862 48.8842 35.593C49.5052 35.5997 50.021 36.0508 50.1147 36.7018C50.4818 39.2518 50.8401 41.8028 51.2023 44.3537C51.3018 45.0569 51.3888 45.762 51.5085 46.4623C51.5317 46.5995 51.6602 46.7502 51.7829 46.8255C51.8437 46.8632 52.033 46.7705 52.1055 46.6864C52.175 46.6063 52.176 46.4614 52.1924 46.3426C52.6077 43.4226 53.0231 40.5027 53.4326 37.5818C53.6036 36.3638 54.4671 35.5968 55.6957 35.5939C56.6839 35.591 57.672 35.6016 58.6611 35.5891C59.4193 35.5794 60.0404 35.0936 60.2413 34.3865C60.5552 33.2796 59.7487 32.2673 58.5413 32.2664C53.6838 32.2635 48.8272 32.2654 43.9696 32.2654V32.2625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_369_3961",
    x: -0.818182,
    y: -0.818182,
    width: 89.6364,
    height: 89.6364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.40909
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.537255 0 0 0 0 0.568627 0 0 0 0 0.611765 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_369_3961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_369_3961",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIce);
export default __webpack_public_path__ + "static/media/ice.e0bcd7e25a9b0f5ea6f693969ee6fe1c.svg";
export { ForwardRef as ReactComponent };